import { useCallback, useEffect, useRef, useState } from 'react';

import { api, getAuthToken } from '../services/api';

import {

  flushBodegaOfflineQueue,

  offlineBodegaQueueCount,

} from '../utils/offlineBodegaQueue';



/**

 * Reenvía canasta/notas guardadas sin internet cuando vuelve la señal.

 */

export default function useOfflineBodegaSync({ enabled = true } = {}) {

  const [pending, setPending] = useState(() => offlineBodegaQueueCount());

  const [syncing, setSyncing] = useState(false);

  const syncingRef = useRef(false);



  const refresh = useCallback(() => {

    setPending(offlineBodegaQueueCount());

  }, []);



  const sync = useCallback(async () => {

    if (!enabled || !getAuthToken() || syncingRef.current) return { sent: 0 };

    if (typeof navigator !== 'undefined' && !navigator.onLine) {

      refresh();

      return { sent: 0 };

    }

    if (!offlineBodegaQueueCount()) {

      refresh();

      return { sent: 0 };

    }



    syncingRef.current = true;

    setSyncing(true);

    try {

      const result = await flushBodegaOfflineQueue({

        saveCanasta: (pedidoId, keys, sep, revision, missingKeys) =>
          api.saveCanasta(pedidoId, keys, sep, revision, missingKeys),

        saveNotas: (pedidoId, notas, sep) => api.saveNotasBodega(pedidoId, notas, sep),

      });

      refresh();

      return { sent: result.sent.length, remaining: result.remaining };

    } finally {

      syncingRef.current = false;

      setSyncing(false);

      refresh();

    }

  }, [enabled, refresh]);



  useEffect(() => {

    if (!enabled) return undefined;

    refresh();

    const onOnline = () => sync();

    const onOffline = () => refresh();

    window.addEventListener('online', onOnline);

    window.addEventListener('offline', onOffline);

    const t = setInterval(() => {

      refresh();

      if (typeof navigator === 'undefined' || navigator.onLine) sync();

    }, 20000);

    sync();

    return () => {

      window.removeEventListener('online', onOnline);

      window.removeEventListener('offline', onOffline);

      clearInterval(t);

    };

  }, [enabled, refresh, sync]);



  return { pending, syncing, syncNow: sync, refresh };

}

